// WatchlistModal Component
// Modal for adding players to watchlist with notes

import React, { useState } from 'react';
import { FaTimes, FaBookmark } from 'react-icons/fa';
import styles from './WatchlistModal.module.css';

const WatchlistModal = ({ isOpen, onClose, player, onSubmit }) => {
  const [notes, setNotes] = useState('');
  const [priority, setPriority] = useState('medium');
  const [tags, setTags] = useState('');

  if (!isOpen || !player) return null;

  // Get profile name and photo from various possible locations
  const playerName = player.name || 
                     (player.userId ? `${player.userId.firstName} ${player.userId.lastName}` : '') ||
                     'Player';
  
  const playerPhoto = player.profilePhoto || 
                     player.media?.profileImage?.cloudinary?.url ||
                     player.media?.profileImage?.url ||
                     null;

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const watchlistData = {
      notes: notes.trim(),
      priority,
      tags: tags.trim().split(',').map(t => t.trim()).filter(Boolean)
    };
    
    onSubmit(watchlistData);
    
    // Reset form
    setNotes('');
    setPriority('medium');
    setTags('');
  };

  return (
    <>
      {/* Modal Backdrop */}
      <div 
        className={styles.backdrop}
        onClick={onClose}
      />
      
      {/* Modal Content */}
      <div className={styles.modal}>
        <div className={styles.header}>
          <h2 className={styles.title}>
            <FaBookmark /> Add to Watchlist
          </h2>
          <button
            className={styles.closeButton}
            onClick={onClose}
          >
            <FaTimes />
          </button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className={styles.playerInfo}>
            {playerPhoto ? (
              <img 
                src={playerPhoto} 
                alt={playerName}
                className={styles.playerPhoto}
              />
            ) : (
              <div className={styles.playerPhotoPlaceholder}>
                {playerName?.charAt(0).toUpperCase()}
              </div>
            )}
            <div>
              <h3 className={styles.playerName}>{playerName}</h3>
              {player.headline && (
                <p className={styles.playerHeadline}>{player.headline}</p>
              )}
            </div>
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="notes">
              Notes (Optional)
            </label>
            <textarea
              id="notes"
              className={styles.textarea}
              value={notes}
              onChange={(e) => setNotes(e.target.value)}
              placeholder="Add any notes about this player..."
              rows={4}
              maxLength={500}
            />
            <p className={styles.charCount}>
              {notes.length}/500 characters
            </p>
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label}>Priority</label>
            <div className={styles.priorityOptions}>
              {['high', 'medium', 'low'].map(level => (
                <label key={level} className={styles.priorityOption}>
                  <input
                    type="radio"
                    name="priority"
                    value={level}
                    checked={priority === level}
                    onChange={(e) => setPriority(e.target.value)}
                  />
                  <span className={`${styles.priorityLabel} ${styles[level]}`}>
                    {level.charAt(0).toUpperCase() + level.slice(1)}
                  </span>
                </label>
              ))}
            </div>
          </div>

          <div className={styles.formGroup}>
            <label className={styles.label} htmlFor="tags">
              Tags (Optional)
            </label>
            <input
              id="tags"
              type="text"
              className={styles.input}
              value={tags}
              onChange={(e) => setTags(e.target.value)}
              placeholder="e.g., fast, technical, leadership (comma separated)"
            />
          </div>

          <div className={styles.actions}>
            <button
              type="button"
              className={styles.cancelButton}
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              type="submit"
              className={styles.submitButton}
            >
              Add to Watchlist
            </button>
          </div>
        </form>
      </div>
    </>
  );
};

export default WatchlistModal;
